// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.UsersRoleSetupAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { compose, withHandlers, setPropTypes } from 'recompose';
import { PropTypes } from 'react';
import { curry, get } from 'lodash/fp';

export default compose(
  setPropTypes({
    store: PropTypes.object.isRequired
  }),
  withHandlers({
    onCheckUser: curry(onCheckUser),
    getData: getData
  })
);

/**
   * handle action Check User
   * @param  {object} props 
   * @param  {object} user  
   * @param  {boolean} value 
   */
function onCheckUser(props: any, user: any, value: any) {
  user && props.store.model.toggleAssignUser(user);
}

/**
   * Get Data for lazy loading
   * @param {Object} pageInfo
   * @param {boolean} isSearching
   */
function getData(props: any) {
  return (pageInfo: any, isSearching: boolean) => {
    const { loader, store, store: { model: { searchedUserName } } } = props;
    const isFirstLoad = pageInfo && get('fromIndex', pageInfo) === 0;
    isFirstLoad && loader.startLoading();
    return store.getPartialUsers(pageInfo, isSearching, searchedUserName).finally(loader.endLoading.bind(loader));
  };
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/Users/Izenda.UsersRoleSetupAction.js